import { render, staticRenderFns } from "./dl.vue?vue&type=template&id=10abebc2&scoped=true"
import script from "./dl.vue?vue&type=script&lang=js"
export * from "./dl.vue?vue&type=script&lang=js"
import style0 from "./dl.vue?vue&type=style&index=0&id=10abebc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abebc2",
  null
  
)

export default component.exports